import { usePlayWalletSync } from 'shared/hooks/use-play-wallet-sync'

/** Keeps the wallet selected for play in sync with the user's linked wallets. */
export const PlayWalletEffect = () => {
  usePlayWalletSync()
  return null
}
